// extracted by mini-css-extract-plugin
export default {"header":"Header_header__epm2F","title":"Header_title__LLcJr","moreBtn":"Header_moreBtn__ggMm4","focus":"Header_focus__Sc6yO"};